import React from 'react';

import { TalentScoutProfileFragment } from '@minecraft.graphql-operations';
import { BaseballCard } from '@minecraft.molecules';
import { WindowWidthContext } from '@minecraft.utils';

import { BasicContainer } from '@minecraft.atoms';
import { SeekingRepresentationBanner } from './SeekingRepresentation';

type ProfileProps = {
  profile: TalentScoutProfileFragment;
  displaySocialMediaSection: boolean;
};

export const Profile = ({ profile, displaySocialMediaSection }: ProfileProps) => {
  const isMobile = WindowWidthContext.useIsMobile();

  return (
    <BaseballCard.Section flexDirection={isMobile ? 'row' : 'column'} grow={1} size="large" wrap="nowrap">
      <BaseballCard.CoverPhoto cover={profile?.cover}>
        {!isMobile && <SeekingRepresentationBanner {...profile} />}
      </BaseballCard.CoverPhoto>
      <BasicContainer w="full">
        <BaseballCard.Section size="small">
          {displaySocialMediaSection && (
            <BasicContainer w="full">
              <BaseballCard.SocialMediaSection socialMedia={profile?.socialMedia} id={String(profile.id)} />
            </BasicContainer>
          )}
          <BaseballCard.StageName {...profile} />
          <BaseballCard.Measurements {...profile} />
          <BaseballCard.Unions {...profile} />
          <BaseballCard.WorkingLocations {...profile} />
          {isMobile && <SeekingRepresentationBanner {...profile} />}
        </BaseballCard.Section>
      </BasicContainer>
    </BaseballCard.Section>
  );
};
